import { render, staticRenderFns } from "./ExternalLinksEditor.vue?vue&type=template&id=b09fca76&"
import script from "./ExternalLinksEditor.vue?vue&type=script&lang=js&"
export * from "./ExternalLinksEditor.vue?vue&type=script&lang=js&"
import style0 from "./ExternalLinksEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports